import "./dashboard.scss";
import {
  React,
  useNavigate,
  useEffect,
  useCallback,
  toast,
  useState,
  LoadingSpinner,
  captureeventbaseanalytics,
  capturepageanalytics,
  Divider,
  Slider,
  Grid,
  Paper,
  Box,
  CircularProgressbar,
  VideosIcon,
  Skeleton,
  SkeletonTheme,
  ImagesIcon,
  WeeklyMediaPostRecord,
  DailyPostStatusChart,
  useGetDashboardStatsMutation,
  createTheme,
  ThemeProvider,
  styled,
  GetCookie,
  RemoveCookie,
  Typography,
  buildStyles,
  Button,
} from "../../Libraries/Dashboard/index";

import { Select } from "../../Libraries/Post/Customization";
import ReactPlayer from "react-player";
import { useMount } from "react-use";
import { SetCookie } from "../../Libraries/Authentication/Login";
import TemporaryDrawer from "../../components/Dashboard/SwipeableDrawer/SwipeableDrawer";
import { useGetAllScreensMutation } from "../../Redux/service/AllEmpData";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Modal from "../../components/Modal";
import Nayatel_Logo from "../../Assets/svgs/Nayatel_Black_Logo.svg";
import Screen from "../../Assets/svgs/screen.svg";
import Storage from "../../Assets/svgs/storage.svg";
import Unlimited_Access from "../../Assets/svgs/unlimited_access.svg";
import Badge from "react-bootstrap/Badge";
import Stack from "react-bootstrap/Stack";
import { Chip } from "@mui/material";
import bgImage from '../../Assets/svgs/dashboard_frame.svg'
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "start",
  color: theme.palette.text.secondary,
  borderRadius: theme.spacing(0),
  boxShadow: "none",
}));

var settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  useTransform: false,
};
const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });

const theme = createTheme({
  palette: {
    white: createColor("#FFFFFF"),
    apple: createColor("#5DBA40"),
    steelBlue: createColor("#5C76B7"),
    violet: createColor("#BC00A3"),
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

theme.typography.h3 = {
  [theme.breakpoints.up("xs")]: {
    fontSize: "1.5rem",
    color: "white",
    fontWeight: "bold",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "1.5rem",
    color: "white",
    fontWeight: "bold",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "1.5rem",
    color: "white",
    fontWeight: "bold",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "1rem",
    color: "white",
    fontWeight: "bold",
  },
  [theme.breakpoints.up("xl")]: {
    fontSize: "1.5rem",
    color: "white",
    fontWeight: "bold",
  },
};
theme.typography.h2 = {
  [theme.breakpoints.up("xs")]: {
    fontSize: "1.5rem",
    color: "#1A75E8",
    fontWeight: "bold",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "1.5rem",
    color: "#1A75E8",
    fontWeight: "bold",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "1.5rem",
    color: "#1A75E8",
    fontWeight: "bold",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "1rem",
    color: "#1A75E8",
    fontWeight: "bold",
  },
  [theme.breakpoints.up("xl")]: {
    fontSize: "1.5rem",
    color: "#1A75E8",
    fontWeight: "bold",
  },
};

const Dashboard = () => {
  const [getInfoForDashboard, { isLoading }] = useGetDashboardStatsMutation();
  const [dashboardInfo, setdashboardInfo] = useState(null);
  const navigate = useNavigate();

  const [open, setopen] = useState(false);
  const [isDrawerOpen, setisDrawerOpen] = useState(false);

  const [data, setData] = useState([]);
  const [getAllScreens] = useGetAllScreensMutation();

  const options = [
    { value: "0", label: "7 days" },
    { value: "1", label: "15 days" },
    { value: "2", label: "30 days" },
  ];
  const [selectedMediaDays, setSelectedMediaDays] = useState(options[0]);

  const getDashboardInfo = useCallback(
    async (mediaDays) => {
      console.log("dashboard = " + mediaDays["value"]);
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("num_of_days_for_media", mediaDays["value"]);

      try {
        const res = await getInfoForDashboard(payload).unwrap();
        if (
          res.connection === "true" &&
          res.status === "true" &&
          res.message === "Stats available"
        ) {
          captureeventbaseanalytics(
            "Dashboard",
            "getInfoForDashboard.php RESPONSE",
            res.message
          );
          setdashboardInfo(res.data);
        } else if (
          res.connection === "true" &&
          res.status === "false" &&
          res.message === "Token expired"
        ) {
          captureeventbaseanalytics(
            "Dashboard",
            "getInfoForDashboard.php RESPONSE",
            res.message
          );
          toast.info(res.message);
          localStorage.removeItem("ser_customer_id");
          RemoveCookie("es_token");
          localStorage.removeItem("ser_code_id");
          localStorage.removeItem("txt_customer_id");
          navigate("/login");
        } else {
          captureeventbaseanalytics(
            "Dashboard",
            "getInfoForDashboard.php RESPONSE",
            res.message
          );
          toast.error(res.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.message);
        captureeventbaseanalytics(
          "Media",
          "getInfoForDashboard.php RESPONSE",
          error.message
        );
      }
    },
    [getInfoForDashboard, navigate]
  );

  const getAllScreensfun = React.useCallback(async () => {
    try {
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", GetCookie("es_token"));
      const result = await getAllScreens(payload).unwrap();
      if (result.status === "true" && result.connection === "true") {
        setData(result.data);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error(error);
    }
  }, [getAllScreens]);

  useEffect(() => {
    capturepageanalytics(window.location.pathname);
    getDashboardInfo(selectedMediaDays);
  }, [getDashboardInfo]);

  useMount(() => {
    const is_first_time_login = GetCookie("is_first_time_login");
    if (is_first_time_login === "true" || is_first_time_login === true) {
      setopen(true);
    }
  });

  const handleCloseModel = () => {
    RemoveCookie("is_first_time_login");
    SetCookie("is_first_time_login", "false");
    setopen(false);
  };

  const showerror = (e) => {
    console.log(e);
  };

  function toggleDrawer(event, value) {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setisDrawerOpen(value);
    if (value) {
      getAllScreensfun();
    }
  }

  function handleMediaRecordData(e) {
    console.log("e = " + e);
    console.log("e = " + e.value);
    console.log("e = " + e.label);

    //Updated Scurity Fixes instead of this:
    // setSelectedMediaDays(options[e.value]);
    //Use This:
    if (Object.prototype.hasOwnProperty.call(options, e.value)) {
      setSelectedMediaDays(options[e.value]);
      //call api here
      // getDashboardInfo(options[e.value]);
    }
    //call api here
    // getDashboardInfo(options[e.value]);
  }

  // "https://639e0e8070196.streamlock.net:8081/vod/default/tour_guide_video_clips/cms_video_for_first_time_login.mp4/playlist.m3u8"

  const NewUserModalView = () => {
    return (
      <ReactPlayer
        // url={
        // "https://6392938d3120a.streamlock.net:8081/vod/default/tour_guide_video_clips/tour_guide_video_for_application_1.mp4/playlist.m3u8"
        // }
        url={
          "https://bbcontent.nayatel.com/content/tour_guide_video_clips/boostboard_demo.mp4"
        }
        height="100%"
        width="100%"
        playing
        muted={true}
        loop={true}
        controls={true}
        onError={(e) => showerror(e)}
      />
    );
  };

  const handleScreenNavigation = () => {
    navigate("/screens", {
      state: [],
    });
  };

  const handleMediaNavigation = () => {
    navigate("/media", {
      state: [],
    });
  };
  const receiverEmail =
    "muneeb.shahid@nayatel.com;sales@nayatel.com;cs@nayatel.com;boostboard@nayatel.com";
  const encodedSubject = encodeURIComponent(
    "Requirements for Additional BoostBoard Screens"
  );
  const encodedBody = encodeURIComponent(
    "Dear Nayatel Team, \n\nI need to add [x number] of BoostBoard screens. \n\nThank you"
  );
  const mailtoUrl = `mailto:${receiverEmail}?subject=${encodedSubject}&body=${encodedBody}`;

  const AddMoreScreenClick = () => {
    window.location.href = mailtoUrl;
  };
  return (
    <>
      <SkeletonTheme baseColor="#F0F0F0" highlightColor="#202020">
        {isLoading ? <LoadingSpinner /> : null}
        <ThemeProvider theme={theme}>
          {isDrawerOpen ? (
            <TemporaryDrawer
              isDrawerOpen={isDrawerOpen}
              toggleDrawer={toggleDrawer}
              data={data}
            />
          ) : null}
          <Box sx={{ flexGrow: 1, mr: 3, mt: 2 }}>
            {/* <div className="border-round">
              <Slider {...settings}>
                {dashboardInfo?.banners?.map((banner) => (
                  <div key={banner.name}>
                    <img
                      src={banner.link}
                      alt="banner"
                      className="slick_banners"
                      width="100%"
                      height="auto"
                      style={{ borderRadius: "8px" }}
                      onClick={() =>
                        window.open(
                          "https://play.google.com/store/apps/details?id=com.nayatel.signage",
                          "_blank"
                        )
                      }
                    />
                  </div>
                ))}
              </Slider>
            </div> */}
            <Box
              sx={{ flexGrow: 1, mt: 4 }}
              id="billing_postStatus_mediaStorage"
            >
              <Grid container spacing={2}>
                {/* Old Dashoboard Card */}
                 <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
                    <Box
                      sx={{
                        flexGrow: 1,
                        p: {
                          xs: "1rem",
                          sm: "1rem",
                          md: "2rem",
                          lg: "1rem",
                          xl: "1rem",
                        },
                      }}
                      className="box h-100 shadow billing cardsmid"
                    >
                      <Item>
                        <div className="flex justify-content-between mb-3">
                          <div>
                            <Typography variant="h3">
                              Trial Information
                            </Typography>

                            <div style={{ color: "#FFFFFF" }} className="mt-2">
                              {dashboardInfo ? (
                                dashboardInfo?.customer_information?.message
                              ) : (
                                <Skeleton />
                              )}
                            </div>

                            <div
                              style={{
                                color: "rgb(255,200,53)",
                                fontSize: "18px",
                                fontWeight: "bold",
                              }}
                              className="mt-2"
                            >
                              Remaining trial days:{" "}
                              <span
                                style={{
                                  color: "#FFFFFF",
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                }}
                              >
                                {dashboardInfo ? (
                                  dashboardInfo?.customer_information
                                    ?.remaining_days_in_trial
                                ) : (
                                  <Skeleton />
                                )}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div
                          className="flex justify-content-between"
                          style={{ marginBottom: "12px" }}
                        >
                          <div>
                            <span
                              className="block font-bold mb-2"
                              style={{ color: "#FFFFFF" }}
                            >
                              Trial period Start
                            </span>
                            <div className="text-900 font-medium text-xl">
                              <span
                                className="block font-bold text-xl mb-2"
                                style={{ color: "#FFFFFF" }}
                              >
                                {dashboardInfo ? (
                                  dashboardInfo?.customer_information
                                    ?.trial_start_date
                                ) : (
                                  <Skeleton />
                                )}
                              </span>
                            </div>
                          </div>
                          <div>
                            <span
                              className="block font-bold mb-2 flex justify-content-end"
                              style={{ color: "rgb(255,200,53)" }}
                            >
                              Trial period End
                            </span>
                            <div className="text-900 font-medium text-xl flex justify-content-end">
                              <span
                                className="block font-bold text-xl "
                                style={{ color: "rgb(255,200,53)" }}
                              >
                                {dashboardInfo ? (
                                  dashboardInfo?.customer_information
                                    ?.trial_end_date
                                ) : (
                                  <Skeleton />
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                        {/* <div className="d-flex justify-content-end">
                          <Button
                            disableElevation
                            color="white"
                            variant="contained"
                            // onClick={() => navigate("/upgrade")}
                          >
                            Subscribe Now
                          </Button>
                        </div> */}
                      </Item>
                    </Box>
                  </Grid>
                {/* Old Dashoboard Card */}
                {/* <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
                  <Box
                    sx={{
                      flexGrow: 1,
                      p: {
                        xs: "1rem",
                        sm: "1rem",
                        md: "2rem",
                        lg: "1rem",
                        xl: "1rem",
                      },
                    }}
                    className="box h-100 shadow billing cardsmid"
                    style={{backgroundImage: `url(${bgImage})`,}}
                  >
                    <Item>
                      <div className="flex flex-column ">
                        <div>
                          <Typography variant="h3" style={{ color: "#FFFFFF",fontSize:"20px",fontWeight:'bold',letterSpacing:0}}>Plan information</Typography>
                          <div style={{ color: "#FFFFFF",fontSize:"14px",fontWeight:'normal' }}>
                            You're using Boostboard Freemium
                          </div>

                          <Stack
                            direction="horizontal"
                            gap={1}
                            className="mt-3 flex-wrap gap-2"
                            style={{ width: "100%", overflow: "hidden" }}
                          >
                            <Badge
                              bg="white"
                              className="rounded-pill d-flex align-items-center gap-2 px-3 py-2 mb-2"
                            >
                              <img
                                src={Screen}
                                alt="Screens"
                                width={15}
                                height={15}
                              />
                              <span
                                style={{ fontSize: "14px", color: "#333333",fontWeight:"500"}}
                              >
                                5 screens
                              </span>
                            </Badge>

                            <Badge
                              bg="white"
                              className="rounded-pill d-flex align-items-center gap-2 px-3 py-2 mb-2 "
                            >
                              <img
                                src={Storage}
                                alt="Storage"
                                width={15}
                                height={15}
                              />
                              <span
                                style={{ fontSize: "14px", color: "#333333",fontWeight:"500" }}
                              >
                                3GB storage
                              </span>
                            </Badge>

                            <Badge
                              bg="white"
                              className="rounded-pill d-flex align-items-center gap-2 px-3 py-2 mb-2"
                            >
                              <img
                                src={Unlimited_Access}
                                alt="Unlimited Access"
                                width={15}
                                height={15}
                              />
                              <span
                                style={{ fontSize: "14px", color: "#333333",fontWeight:"500" }}
                              >
                                Unlimited access
                              </span>
                            </Badge>
                          </Stack>
                        </div>
                      </div>

                      <div className="d-flex align-items-center justify-content-between mt-7 flex-end gap-0">
                        <div
                          style={{
                            color: "#FFFFFF",
                            fontSize: "14px",
                            fontWeight: "400",
                           
                          }}
                        >
                          Running out of screens or need something tailored?
                        </div>
                        <Chip
                          label="Request customization"
                          onClick={AddMoreScreenClick}
                          className="rounded-pill dashbtn"
                          // style={{
                          //   backgroundColor: "#F56421",
                          //   fontSize: "14px",
                          //   fontWeight: "600",
                          //   textAlign: "center",
                          //   color: "white",
                          //   paddingInline:"0.2rem",
                          //   height:"44px"
                          // }}
                        />
                      </div>
                    </Item>
                  </Box>
                </Grid> */}

                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                  <Box
                    sx={{
                      flexGrow: 1,
                      p: {
                        xs: "1rem",
                        sm: "1rem",
                        md: "2rem",
                        lg: "1rem",
                        xl: "1rem",
                      },
                    }}
                    className="box h-100 shadow surface-0 cardsmid"
                  >
                    <Item>
                      <div className="d-flex justify-content-between">
                        <div>
                          <Typography
                            variant="h2"
                            onClick={() => handleScreenNavigation()}
                            style={{ cursor: "pointer" ,fontSize:"20px"}}
                          >
                            Screens
                          </Typography>
                        </div>
                        <div className="screen_detail">
                          <span
                            onClick={(e) => toggleDrawer(e, true)}
                            tabIndex={0}
                          >
                            Details
                          </span>
                        </div>
                      </div>

                      <Box sx={{ flexGrow: 1, mt: 2 }}>
                        <Grid
                          container
                          direction="row"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          p={1}
                        >
                          <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                            <Item>
                              <span className="dot"></span>
                            </Item>
                          </Grid>
                          <Grid item xs={7} sm={7} md={7} lg={9} xl={7}>
                            <Item>
                              <span style={{ color: "black", fontWeight: 500 }}>
                                Active Screen
                              </span>
                            </Item>
                          </Grid>
                          <Grid
                            item
                            xs={4}
                            sm={4}
                            md={4}
                            lg={2}
                            xl={4}
                            justifyContent="end"
                            display="flex"
                          >
                            <Item>
                              <span
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                }}
                              >
                                {dashboardInfo
                                  ? dashboardInfo?.screens
                                      ?.mapped_screens_counter
                                  : 0}
                              </span>
                            </Item>
                          </Grid>
                        </Grid>
                        <hr className="new2 mb-1" />
                        <Grid
                          container
                          direction="row"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          p={1}
                        >
                          <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                            <Item>
                              <span className="dot1"></span>
                            </Item>
                          </Grid>
                          <Grid item xs={7} sm={7} md={7} lg={10} xl={7}>
                            <Item>
                              <span style={{ color: "black", fontWeight: 500 }}>
                                Non-Active Screen
                              </span>
                            </Item>
                          </Grid>

                          <Grid
                            item
                            xs={4}
                            sm={4}
                            md={4}
                            lg={1}
                            xl={4}
                            justifyContent="end"
                            display="flex"
                          >
                            <Item>
                              <span
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                }}
                              >
                                {dashboardInfo
                                  ? dashboardInfo?.screens
                                      ?.unmapped_screens_counter
                                  : 0}
                              </span>
                            </Item>
                          </Grid>
                        </Grid>

                        <hr className="new2" />

                        <Grid
                          container
                          direction="row"
                          display="flex"
                          justifyContent="right"
                          alignItems="right"
                          p={1}
                          mt={3}
                        >
                          <Grid item xs={12} md={9} lg={9} xl={9}>
                            <Item>
                              <Button
                                variant="text"
                                fontWeight="bold"
                                endIcon={<ArrowForwardIosIcon />}
                                onClick={() => handleScreenNavigation()}
                                sx={{
                                  width: "100%",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <span style={{ fontWeight: "bold",textTransform:"capitalize"}}>
                                  {" "}
                                  Manage Screens{" "}
                                </span>
                              </Button>
                            </Item>
                          </Grid>
                        </Grid>

                        {/* <div
                          className="d-flex justify-content-center"
                          style={{ marginTop: "15px" }}
                        >
                          <Button
                            variant="contained"
                            onClick={() => navigate("/billing")}
                            sx={{ width: "100%" }}
                          >
                            Purchase Now
                          </Button>
                        </div> */}
                      </Box>
                    </Item>
                  </Box>
                </Grid>


                <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                  <Box
                    sx={{
                      flexGrow: 1,
                      p: {
                        xs: "1rem",
                        sm: "1rem",
                        md: "2rem",
                        lg: "1rem",
                        xl: "1rem",
                      },
                    }}
                    className="box h-100 shadow surface-0 cardsmid"
                  >
                    <Item>
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <Typography
                          variant="h2"
                          onClick={() => handleMediaNavigation()}
                          style={{ cursor: "pointer",fontSize:"20px",fontWeight:"700" }}
                        >
                          Media
                        </Typography>
                        <span>
                          {" "}
                          <span
                            style={{ color: "#1A75E8", fontWeight: "bold" }}
                          >
                            {dashboardInfo?.media?.space_available}
                          </span>{" "}
                          / {dashboardInfo?.media?.total_space} Free
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <div className="text-900 font-medium text-xl">
                          <Grid container direction="row" alignItems="center">
                            <Grid item>
                              <div
                                className="d-flex align-items-center justify-content-center bg-blue-100 border-round mr-2"
                                style={{ width: "2.3rem", height: "2.3rem" }}
                              >
                                <img src={VideosIcon} alt="d" />
                              </div>
                            </Grid>
                            <Grid item>
                              <div>
                                <span
                                  className="block font-bold"
                                  style={{ color: "#504F4F", fontSize: "16px" ,fontWeight:"600"}}
                                >
                                  {dashboardInfo?.media?.total_videos} Videos
                                </span>
                                <div
                                  className=""
                                  style={{ color: "#504F4F", fontSize: "12px" }}
                                >
                                  {dashboardInfo?.media?.total_videos_size}
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                          <Divider
                            sx={{
                              borderBottomWidth: 2,
                              background: "#000000",
                              marginTop: "5px",
                              marginBottom: "5px",
                            }}
                          />
                          <Grid container direction="row" alignItems="center">
                            <Grid item>
                              <div
                                className="flex align-items-center justify-content-center bg-blue-100 border-round mr-2"
                                style={{ width: "2.3rem", height: "2.3rem" }}
                              >
                                <img src={ImagesIcon} alt="d" />
                              </div>
                            </Grid>
                            <Grid item>
                              <div>
                                <span
                                  className="block font-bold"
                                  style={{ color: "#504F4F", fontSize: "16px" ,fontWeight:"600"}}
                                >
                                  {dashboardInfo?.media?.total_images} Images
                                </span>
                                <div
                                  className=""
                                  style={{ color: "#504F4F", fontSize: "12px" }}
                                >
                                  {dashboardInfo?.media?.total_images_size}
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        <div style={{ width: 90, height: 90 }}>
                          <CircularProgressbar
                            value={dashboardInfo?.media?.percentage}
                            strokeColor={{
                              "0%": "#108ee9",
                              "100%": "#87d068",
                            }}
                            text={`${
                              dashboardInfo
                                ? dashboardInfo.media?.percentage
                                : ""
                            }%`}
                            strokeWidth={15}
                            strokeLinecap="round"
                            styles={buildStyles({
                              strokeLinecap: "butt",
                              textSize: "16px",
                              pathTransitionDuration: 0.5,
                              pathColor: `#1A75E8`,
                              textColor: "#000000",
                              trailColor: "#d6d6d6",
                              backgroundColor: "#3e98c7",
                            })}
                          />
                        </div>
                      </div>
                      {/* <h5 className="d-flex justify-content-center pt-2">
                        <span style={{ color: "#1A75E8" }}>
                          {dashboardInfo?.media?.space_available}
                        </span>
                        &nbsp; REMAINING
                      </h5> */}
                    </Item>

                    <Grid
                      container
                      direction="row"
                      display="flex"
                      justifyContent="right"
                      alignItems="right"
                      p={1}
                      mt={2}
                    >
                      <Grid item xs={12} md={8} lg={8} xl={8}>
                        <Item>
                          <Button
                            variant="text"
                            fontWeight="bold"
                            endIcon={<ArrowForwardIosIcon />}
                            onClick={() => handleMediaNavigation()}
                            sx={{ width: "100%", justifyContent: "flex-end" }}
                          >
                            <span style={{ fontWeight: "bold",textTransform:"capitalize" }}>
                              Manage Media
                            </span>
                          </Button>
                        </Item>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ flexGrow: 1, mt: 2 }} id="screens_dailymediarecord">
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={6} xl={6}>
                  <Box
                    sx={{ flexGrow: 1 }}
                    className="box h-100 shadow surface-0 p-3 cardsmid"
                  >
                    <Item>
                      <div className="d-flex justify-content-between">
                        <span
                          className="font-bold text-xl"
                          style={{ color: "#1A75E8" ,fontSize:"20px"}}
                        >
                          {/* Weekly Post Status */}
                          Screen Wise Media
                        </span>
                      </div>
                      <DailyPostStatusChart
                        dashboardInfo={dashboardInfo?.screenwise_media_count}
                      />
                    </Item>
                  </Box>
                </Grid>

                <Grid item xs={12} md={12} lg={6} xl={6}>
                  <div className="box h-100 d-flex flex-column shadow surface-0 p-3 cardsmid">
                    <Item>
                      <div className="flex justify-content-between">
                        <span
                          style={{
                            color: "#1A75E8",
                            fontSize: "20px",
                            fontWeight: "bold",
                          }}
                        >
                          Media Record
                        </span>

                        <span
                          style={{
                            color: "#1A75E8",
                            fontSize: "18px",
                            fontWeight: "bold",
                          }}
                        >
                          <Select
                            isMulti={false}
                            options={options}
                            value={selectedMediaDays}
                            onChange={(e) => {
                              handleMediaRecordData(e);
                            }}
                            isClearable={false}
                            placeholder={"Select"}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                          />
                        </span>
                      </div>
                      <WeeklyMediaPostRecord
                        dashboardInfo={dashboardInfo?.date_wise_media_upload}
                      />
                    </Item>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Box
            sx={{
              marginLeft: "auto",
              display: "flex",
              flexDirection: "column",
              paddingInline: "3rem",
              paddingTop: "0.5rem",
            }}
            className="mt-2"
          >
            <Typography
              style={{
                color: "#757575",
                fontStyle: "italic",
                fontSize: "12px",
                fontWeight: "600",
                marginLeft: "auto",
                paddingRight: "2rem",
                marginRight: "10px",
              }}
              variant="h6"
            >
              Powered by
            </Typography>
            <img
              src={Nayatel_Logo}
              alt="nayatel_img"
              style={{
                marginLeft: "auto",
                marginTop: "0.4rem",
                height: "21.98px",
                width:"103.07px",
              }}
            />
          </Box>
          {open ? (
            <Modal open={open} onCloseModal={handleCloseModel} padding={false} closeicon ={true} closeOnEsc={true}>
              {NewUserModalView()}
            </Modal>
          ) : null}
        </ThemeProvider>
      </SkeletonTheme>
    </>
  );
};
export default Dashboard;
